
export class Usuario {
    nome: string;
    senha: string;
    login: string;
}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/login/usuario.ts